import loadable from "@loadable/component";

export const CartItemCountdown = loadable(
  () => import(/* webpackChunkName: "client-ui" */ "./cart-item-countdown"),
  { ssr: false });

export const ProtectedRoute = loadable(
  () => import(/* webpackChunkName: "client-ui" */ "./protected-route"),
  { ssr: false });

export const NotFoundWithoutLocalePrefix = loadable(
  () => import(/* webpackChunkName: "client-ui" */ "./not-found"),
  { ssr: false });

export const test = loadable.lib(
  () => import(/* webpackChunkName: "client-ui" */"./recaptcha"),
  { ssr: false });
